export default function footerForm() {
    var elements = document.querySelectorAll(".geposit-footer-content__form-wrapper-newsletter \n  .empori-form \n  .form-node");
    if (elements && elements.length === 2) {
        elements[0].classList.add('node-extra-width');
        elements[1].classList.add('node-less-width');
    }
}
;
